import styled from 'styled-components'

export const ListWrapper = styled.div<{
  $sideMargin: number
}>`
  position: relative;
  margin: 0 ${({ $sideMargin }) => $sideMargin}px;
`
